<template>
  <div>
    <before-you-go-modal
      :show="showModal"
      :membership-months="membershipMonths"
      :is-trialing="isTrialing"
      :trial-charge-date="trialChargeDate"
      @keep="onKeep"
      @continue="onContinue"
      @close="onModalClose"
      @video-played="onVideoPlayed"
      @contact-support="onContactSupport"
    />
  </div>
</template>

<script>
import posthog from "posthog-js"
import { openSupport } from "@/utils/open-support"
import BeforeYouGoModal from "@/features/settings/components/before-you-go-modal"

const SURFACE = "billing_portal"
const TRIGGER_SELECTOR = "[data-billing-portal-cancel-trigger]"

// Stripe (stripe_v3) subscribers cancel via the billing portal rather than the Vue
// cancel-subscription flow. We intercept any billing-portal cancel link (top "Cancel
// subscription" + the cancellation section) and show the before-you-go retention modal
// before sending them to the portal. A single delegated listener covers every trigger
// on the page.
export default {
  name: "BillingPortalCancel",
  components: {
    BeforeYouGoModal
  },
  props: {
    portalUrl: {
      type: String,
      default: "/billing-portal/return"
    },
    membershipMonths: {
      type: Number,
      default: 0
    },
    isTrialing: {
      type: Boolean,
      default: false
    },
    trialChargeDate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showModal: false,
      pendingUrl: null,
      outcomeRecorded: false
    }
  },
  mounted() {
    document.addEventListener("click", this.onDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick)
  },
  methods: {
    onDocumentClick(event) {
      const trigger = event.target.closest(TRIGGER_SELECTOR)
      // only intercept clicks on a billing-portal cancel trigger
      if (!trigger) return

      event.preventDefault()
      this.pendingUrl = trigger.getAttribute("href") || this.portalUrl
      this.outcomeRecorded = false
      this.showModal = true
      posthog.capture("cancel_before_you_go_shown", { surface: SURFACE })
    },
    onKeep() {
      this.recordOutcome("kept")
      this.showModal = false
    },
    onContinue() {
      this.recordOutcome("continued")
      window.location.assign(this.pendingUrl || this.portalUrl)
    },
    onModalClose() {
      this.recordOutcome("dismissed")
      this.showModal = false
    },
    onVideoPlayed() {
      posthog.capture("cancel_before_you_go_video_played", { surface: SURFACE })
    },
    onContactSupport() {
      this.recordOutcome("support")
      this.showModal = false
      openSupport()
    },
    recordOutcome(outcome) {
      if (this.outcomeRecorded) return
      this.outcomeRecorded = true
      posthog.capture("cancel_before_you_go_resolved", { outcome, surface: SURFACE })
    }
  }
}
</script>
